// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__w+mVd","total":"AdvancePaymentDetails_total__8cSF7","edit":"AdvancePaymentDetails_edit__0BidW"};